var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isVerificationShow,
          expression: "isVerificationShow"
        }
      ],
      staticClass: "puzzle-container"
    },
    [
      _c("div", { staticClass: "puzzle-header" }, [
        _c("span", { staticClass: "puzzle-header-left" }, [
          _vm._v("拖动下方滑块完成拼图")
        ]),
        _vm._v(" "),
        _c("div", [
          _c("span", {
            staticClass: "re-btn iconfont icon-shuaxin",
            on: { click: _vm.refreshImg }
          }),
          _vm._v(" "),
          _c("span", {
            staticClass: "close-btn iconfont icon-guanbi",
            on: { click: _vm.closeVerificationBox }
          })
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          style:
            "position:relative;overflow:hidden;width:" + _vm.dataWidth + "px;"
        },
        [
          _c(
            "div",
            {
              style:
                "position:relative;width:" +
                _vm.dataWidth +
                "px;height:" +
                _vm.dataHeight +
                "px;"
            },
            [
              _c("img", {
                ref: "scream",
                style:
                  "width:" +
                  _vm.dataWidth +
                  "px;height:" +
                  _vm.dataHeight +
                  "px;",
                attrs: { id: "scream", src: _vm.imgRandom }
              }),
              _vm._v(" "),
              _c("canvas", {
                ref: "puzzleBox",
                attrs: {
                  id: "puzzle-box",
                  width: _vm.dataWidth,
                  height: _vm.dataHeight
                }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "puzzle-lost-box",
              style:
                "left:" +
                _vm.left_Num +
                "px;width:" +
                _vm.dataWidth +
                "px;height:" +
                _vm.dataHeight +
                "px;"
            },
            [
              _c("canvas", {
                ref: "puzzleShadow",
                attrs: {
                  id: "puzzle-shadow",
                  width: _vm.dataWidth,
                  height: _vm.dataHeight
                }
              }),
              _vm._v(" "),
              _c("canvas", {
                ref: "puzzleLost",
                attrs: {
                  id: "puzzle-lost",
                  width: _vm.dataWidth,
                  height: _vm.dataHeight
                }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "p",
            {
              ref: "verTips",
              class: "ver-tips" + (_vm.displayTips ? " slider-tips" : "")
            },
            [
              _vm.verification
                ? [
                    _c("i", {
                      staticStyle: { "background-position": "-4px -1207px" }
                    }),
                    _vm._v(" "),
                    _c("span", { staticStyle: { color: "#42ca6b" } }, [
                      _vm._v("验证通过")
                    ]),
                    _vm._v(" "),
                    _c("span")
                  ]
                : _vm._e(),
              _vm._v(" "),
              !_vm.verification
                ? [
                    _c("i", {
                      staticStyle: { "background-position": "-4px -1229px" }
                    }),
                    _vm._v(" "),
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("验证失败:")
                    ]),
                    _vm._v(" "),
                    _c("span", { staticStyle: { "margin-left": "4px" } }, [
                      _vm._v("拖动滑块将悬浮图像正确拼合")
                    ])
                  ]
                : _vm._e()
            ],
            2
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "slider-container",
          style: "width:" + _vm.dataWidth + "px;"
        },
        [
          _c("div", { staticClass: "slider-bar" }),
          _vm._v(" "),
          _c("div", {
            ref: "sliderBtn",
            staticClass: "slider-btn",
            on: { mousedown: _vm.startMove, touchstart: _vm.startMove }
          })
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6d4bc492", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d4bc492","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/puzzleVerification.vue
// module id = 15
// module chunks = 0